import React from 'react'
import styled from 'styled-components'
import { lightThemeColors } from '../../assets/style/colors'
import { motion } from 'framer-motion'
import AnimatedTextButton from '../generic/AnimatedTextButton'

const UsecaseCard = ({ highlight, title, subtitle, description, seeMore }) => {
    return (
        <Container>
            <TitleWrapper

            >
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
            </TitleWrapper>
            <Separator />
            <TextWrapper

            >

                <Description>{description}</Description>
                <Highlight>{highlight}</Highlight>
                {seeMore &&
                    <AnimatedTextButton
                        text={"See more"}
                        style={{ color: lightThemeColors.lightColor, borderBottom: `1px solid ${lightThemeColors.lightColor}` }}
                        textColor={lightThemeColors.lightColor}
                        onClick={seeMore}
                    />}

            </TextWrapper>
        </Container>
    )
}

export default UsecaseCard
const Container = styled.div`
background:${lightThemeColors.howWorkCardBg};
overflow:hidden;
display:flex;
flex-direction:column;
gap:20px;
width:100%;
height:100%;
gap:20px;
padding:40px;
border-radius:8px;
`
const TextWrapper = styled.div`
display:flex;
flex-direction:column;
gap:20px;
`
const TitleWrapper = styled.div`
display:flex;
flex-direction:column;
gap:10px;
`

const Title = styled.h3`
color:${lightThemeColors.lightColor};
font-weight: 700;
font-size: 28px;
line-height: 32px
`
const Subtitle = styled.p`
color:${lightThemeColors.lightColor};
font-weight: 400;
font-size: 20px;
line-height: 24px;

`
const Description = styled.p`
color:rgba(213, 213, 213, 1);
font-weight: 400;
font-size: 18px;
line-height: 24px;
`
const Highlight = styled(Description)`
color:${lightThemeColors.lightColor};
font-weight: 700;
`

const Separator = styled.div`
min-height:1px;
display:flex;
width:100%;
background:rgba(68, 67, 66, 1);
`